import React, { Suspense, lazy, useEffect, useState, useCallback } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import UserList from '../../components/Users/UserList';
import {
    getUserDetailById,
    getAllAdminUsers,
} from '../../../services/UserService';

const AddUser = lazy(() =>
    import(/* webpackChunkName: "AddUser" */ '../../components/Users/AddUser')
);

const notify = (id, type, message, time) => {
    toast.update(id, {
        render: message,
        type: type,
        position: 'top-center',
        autoClose: time,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        isLoading: false,
    });
};

const Users = () => {
    const [userId, setUserId] = useState();
    const [userDetails, setUserDetails] = useState();
    const [addCard, setAddCard] = useState(false);
    const [userList, setUserList] = useState({
        data: [],
        columns: ['', 'Name', 'Mobile', 'Designation', 'Email', 'Action'],
    });
    const [jobPagination, setJobPagination] = useState();
    const [jobData, setJobData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0
    });
    const sort = 5;

    const getUserList = useCallback((page = 1, pageItems = 10) => {
        setIsLoading(true);
        getAllAdminUsers(page, pageItems).then(data => {
            // Check if data exists and is an array
            if (Array.isArray(data)) {
                let newArray = [];
                data.forEach((each, index) => {
                    let testArray = [];
                    testArray[0] =
                        process.env.REACT_APP_API_RESOURCE_URL + each.image;
                    testArray[1] = each.full_name;
                    testArray[2] = each.mob;
                    testArray[3] = each.designation;
                    testArray[4] = each.email;
                    testArray[5] = each.id;
                    newArray[index] = testArray;
                });
                let userListData = {
                    columns: [
                        '',
                        'NAME',
                        'MOBILE',
                        'DESIGNATION',
                        'EMAIL',
                        'ACTION',
                    ],
                    data: newArray,
                };
                setUserList(userListData);
                setJobData(newArray);
                
                // Set pagination based on data length
                const totalItems = data.length;
                const totalPages = Math.ceil(totalItems / pageItems);
                setPagination({
                    currentPage: page,
                    totalPages: totalPages,
                    totalItems: totalItems
                });
                
                setJobPagination(
                    Array(Math.max(1, totalPages))
                        .fill()
                        .map((_, i) => i + 1)
                );
            } else {
                // Handle case when data is not an array
                console.error('Invalid data format received from API');
                setUserList({
                    data: [],
                    columns: ['', 'Name', 'Mobile', 'Designation', 'Email', 'Action'],
                });
                setJobData([]);
                setPagination({
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                });
                setJobPagination([1]);
            }
            setIsLoading(false);
        }).catch(error => {
            console.error('Error fetching user data:', error);
            setIsLoading(false);
        });
    }, []);

    // add new user
    const handleAddNew = () => {
        setAddCard(true);
    };

    // edit existing user
    const handleEdit = id => {
        setAddCard(true);
        setUserId(id);
        getUserDetailById(id).then(res => {
            setUserDetails(res);
        });
    };

    useEffect(() => {
        if (!addCard) {
            setUserId('');
            setUserDetails('');
        }
    }, [addCard]);

    return (
        <>
            <Suspense
                fallback={
                    <div id='preloader-inner'>
                        <div className='sk-three-bounce-inner'>
                            <div className='sk-child sk-bounce1'></div>
                            <div className='sk-child sk-bounce2'></div>
                            <div className='sk-child sk-bounce3'></div>
                            <div id='preloader-inner-bg'></div>
                        </div>
                    </div>
                }
            >
                {addCard ? (
                    <AddUser
                        addCard={addCard}
                        setAddCard={setAddCard}
                        userId={userId}
                        userDetails={userDetails}
                        getUserList={getUserList}
                        notify={notify}
                        toast={toast}
                    />
                ) : (
                    ''
                )}
            </Suspense>
            <ToastContainer
                position='top-center'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <UserList
                userList={userList}
                jobData={jobData}
                jobPagination={jobPagination}
                handleAddNew={handleAddNew}
                handleEdit={handleEdit}
                getUserList={getUserList}
                setJobData={setJobData}
                sort={sort}
                isLoading={isLoading}
            />
        </>
    );
};
export default Users;
